var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        persistent: "",
        "hide-overlay": "",
        transition: "dialog-bottom-transition",
        width: _vm.$vuetify.breakpoint.smAndDown ? "100vw" : "65vw",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  on: {
                    click: function ($event) {
                      return _vm.Close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
              _c("v-toolbar-title", [_vm._v("Cadastro Equipe")]),
              _c("v-spacer"),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { dark: "", text: "", disabled: !_vm.valid },
                      on: {
                        click: function ($event) {
                          return _vm.Salvar()
                        },
                      },
                    },
                    [_vm._v("Salvar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              model: {
                value: _vm.valid,
                callback: function ($$v) {
                  _vm.valid = $$v
                },
                expression: "valid",
              },
            },
            [
              _c(
                "v-card-text",
                { staticClass: "mt-3" },
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Nome",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.nome,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "nome", $$v)
                              },
                              expression: "item.nome",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Função no projeto",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.funcao,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "funcao", $$v)
                              },
                              expression: "item.funcao",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "12" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              label: "Formação e experiência profissional",
                              counter: 1000,
                              maxlength: "1000",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.formacaoExperiencia,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "formacaoExperiencia", $$v)
                              },
                              expression: "item.formacaoExperiencia",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Carga horária",
                              rules: _vm.fieldRules,
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.cargaHoraria,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "cargaHoraria", $$v)
                              },
                              expression: "item.cargaHoraria",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "12", md: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.formas,
                              "item-value": "id",
                              "item-text": "nome",
                              label: "Forma de contratação",
                              dense: "",
                              outlined: "",
                            },
                            model: {
                              value: _vm.item.formaContratacao,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "formaContratacao", $$v)
                              },
                              expression: "item.formaContratacao",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }